import { render, staticRenderFns } from "./ExpoModalComponent.vue?vue&type=template&id=16df5b5e&scoped=true&"
import script from "./ExpoModalComponent.vue?vue&type=script&lang=js&"
export * from "./ExpoModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExpoModalComponent.vue?vue&type=style&index=0&id=16df5b5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df5b5e",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BLink, BRow, BContainer, BModal} from 'bootstrap-vue'
    installComponents(component, {BButton, BLink, BRow, BContainer, BModal})
    

export default component.exports